export default __webpack_public_path__ + "static/media/Ballroll_00103.a8492ee3.png";